import { getAuthHeaders } from "./authService";

const domain = process.env.REACT_APP_DOMAIN;

export async function fetchCompanyActivityLogs({
  page = 1,
  limit = 30,
  event_type = "",
  user_id = "",
  user_search = "",
  date_from = "",
  date_to = "",
}) {
  const params = new URLSearchParams({ page, limit, event_type, user_id, user_search, date_from, date_to });
  const res = await fetch(`${domain}/api/v1/company/activity-logs?${params}`, {
    headers: getAuthHeaders(),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data?.error || "Failed to fetch logs");
  return data;
}
